(function () {
  function createCoveoDistanceModule(deps) {
    let domDistanceFilterRunId = 0;
    const coveoLocationContextCacheKey =
      typeof deps?.coveoLocationContextCacheKey === "function"
        ? deps.coveoLocationContextCacheKey
        : function () {
          return "";
        };
    const getActiveCoveoLocationContext =
      typeof deps?.getActiveCoveoLocationContext === "function"
        ? deps.getActiveCoveoLocationContext
        : function () {
          return null;
        };
    const getActiveCoveoStoredLocation =
      typeof deps?.getActiveCoveoStoredLocation === "function"
        ? deps.getActiveCoveoStoredLocation
        : function () {
          return null;
        };
    const getActiveKeywordQuery =
      typeof deps?.getActiveKeywordQuery === "function"
        ? deps.getActiveKeywordQuery
        : function () {
          return "";
        };
    const getCoveoQuerySummaryElements =
      typeof deps?.getCoveoQuerySummaryElements === "function"
        ? deps.getCoveoQuerySummaryElements
        : function () {
          return [];
        };
    const isCoveoProductNavigationPendingActive =
      typeof deps?.isCoveoProductNavigationPendingActive === "function"
        ? deps.isCoveoProductNavigationPendingActive
        : function () {
          return false;
        };
    const normalizeUsZipPrefix =
      typeof deps?.normalizeUsZipPrefix === "function"
        ? deps.normalizeUsZipPrefix
        : function (zip) {
          const digits = String(zip || "")
            .replace(/\D/g, "")
            .slice(0, 5);
          return digits.length >= 5 ? digits : "";
        };
    const parseGeoCoordinate =
      typeof deps?.parseGeoCoordinate === "function"
        ? deps.parseGeoCoordinate
        : function (value) {
          const n = parseFloat(String(value || "").trim());
          return Number.isFinite(n) ? n : NaN;
        };
    const setCoveoDomDistanceAppliedCtxKey =
      typeof deps?.setCoveoDomDistanceAppliedCtxKey === "function"
        ? deps.setCoveoDomDistanceAppliedCtxKey
        : function () { };

    function getCardDealerPlaceOpts(card) {
      if (!card) return null;
      const place = (card.getAttribute("data-dealer-place") || "").trim();
      const city = (card.getAttribute("data-dealer-city") || "").trim();
      const state = (card.getAttribute("data-dealer-state") || "").trim();
      const zip = (card.getAttribute("data-dealer-zip") || "").trim();
      if (!place && !city && !state && !zip) return null;
      return { place, city, state, zip };
    }

    function cardMatchesUserZipRadius(card, userZip, radiusMiles) {
      const cardZip = normalizeUsZipPrefix(
        card.getAttribute("data-dealer-zip") || "",
      );
      const searchZip = normalizeUsZipPrefix(userZip);
      if (!cardZip || !searchZip) return false;
      if (cardZip === searchZip) return true;
      if (Number(radiusMiles) >= 50 && cardZip.slice(0, 3) === searchZip.slice(0, 3)) {
        return true;
      }
      return false;
    }

    function getCoveoDistanceGridItems(productsEl) {
      if (!productsEl || !productsEl.children) return [];
      return Array.from(productsEl.children).filter((el) => {
        return (
          el &&
          el.nodeType === 1 &&
          el.matches(
            ".f-column, .coveo-search-card-wrapper, .coveo-search-card, .coveo-boat-card, .coveo-product-card",
          )
        );
      });
    }

    function setCoveoSourceIndex(item, index) {
      if (!item || item.nodeType !== 1) return;
      if (!Number.isFinite(index)) return;
      item.setAttribute("data-coveo-source-index", String(index));
    }

    function getCoveoDistanceCardFromGridItem(item) {
      if (!item || item.nodeType !== 1) return null;
      if (
        item.matches(".coveo-search-card, .coveo-boat-card, .coveo-product-card")
      ) {
        return item;
      }
      return item.querySelector(
        ".coveo-search-card, .coveo-boat-card, .coveo-product-card",
      );
    }

    function resetDomDistanceFilteredColumns(productsEl) {
      if (!productsEl) return;
      getCoveoDistanceGridItems(productsEl).forEach((col) => {
        col.hidden = false;
        col.removeAttribute("hidden");
        col.style.removeProperty("display");
        col.classList.remove("is-distance-filtered-out");
        col.removeAttribute("data-distance-filtered");
        col.removeAttribute("aria-hidden");
      });
    }

    function syncCoveoDistanceProductsGridVisibility(productsEl) {
      if (!productsEl) return;
      const ctx = getActiveCoveoLocationContext();
      if (!ctx) {
        productsEl.classList.remove(
          "coveo-products--distance-zero-visible",
          "coveo-products--distance-filter-pending",
        );
        productsEl.removeAttribute("aria-hidden");
        productsEl.style.removeProperty("display");
        return;
      }
      const visible = window.__coveoDomDistanceVisibleCount;
      const pending = window.__coveoDomDistanceFilterPending;
      const hideAll =
        !pending && typeof visible === "number" && visible === 0;
      productsEl.classList.toggle(
        "coveo-products--distance-zero-visible",
        hideAll,
      );
      productsEl.classList.toggle(
        "coveo-products--distance-filter-pending",
        Boolean(pending),
      );
      if (hideAll) {
        productsEl.setAttribute("aria-hidden", "true");
        productsEl.style.setProperty("display", "none", "important");
      } else {
        productsEl.removeAttribute("aria-hidden");
        productsEl.style.removeProperty("display");
      }
    }

    function refreshCoveoDistanceSummaryAndPagination() {
      const summaryEls = getCoveoQuerySummaryElements();
      const summaryEl = summaryEls[0] || null;
      const paginationEl = document.getElementById("coveo-pagination");
      const noResultsEl = document.getElementById("coveo-no-results");
      const productsEl = document.getElementById("coveo-products");
      const activeRoot =
        document.getElementById("coveo-headless-search") ||
        document.getElementById("coveo-headless-collection") ||
        productsEl?.closest?.("#coveo-headless-search, #coveo-headless-collection") ||
        null;
      const activeController =
        activeRoot?._coveoSearch || window.CoveoSearchController || null;
      const ctx = getActiveCoveoLocationContext();
      if (!ctx || !summaryEl) return;

      const radiusMi = ctx.location_radius_miles;
      const visible = window.__coveoDomDistanceVisibleCount;
      const pending = window.__coveoDomDistanceFilterPending;
      const usesServerSideDistanceFiltering =
        window.__coveoClientOnlyDistanceFilter === false;
      const serverSummary =
        window.__coveoDistanceServerSummary &&
        typeof window.__coveoDistanceServerSummary === "object"
          ? window.__coveoDistanceServerSummary
          : null;
      const activeQueryText = String(
        getActiveKeywordQuery(activeController, activeRoot) || "",
      ).trim();
      const formatShortResultsText = (value) => {
        const safeValue = Math.max(0, Number(value) || 0);
        const baseText = `${safeValue.toLocaleString()} Results`;
        return activeQueryText ? `${baseText} for "${activeQueryText}"` : baseText;
      };

      if (pending) {
        summaryEls.forEach((el) => {
          el.textContent = activeQueryText
            ? `Finding results for "${activeQueryText}"…`
            : "Finding results…";
        });
      } else if (typeof visible === "number") {
        if (window.__coveoDistanceFilterGracefulFallback) {
          const fallbackTotal =
            serverSummary && Number.isFinite(serverSummary.total) && serverSummary.total > 0
              ? serverSummary.total
              : visible;
          summaryEls.forEach((el) => {
            el.textContent = formatShortResultsText(fallbackTotal);
          });
        } else if (visible > 0) {
          const resolvedTotal =
            usesServerSideDistanceFiltering &&
            serverSummary &&
            Number.isFinite(serverSummary.total) &&
            serverSummary.total > 0
              ? serverSummary.total
              : visible;
          summaryEls.forEach((el) => {
            el.textContent = formatShortResultsText(resolvedTotal);
          });
        } else if (window.__coveoDistanceFilterNoIndexedGeo) {
          summaryEls.forEach((el) => {
            el.textContent = activeQueryText
              ? `0 Results for "${activeQueryText}"`
              : "0 Results";
          });
        } else {
          summaryEls.forEach((el) => {
            el.textContent = activeQueryText
              ? `0 Results for "${activeQueryText}"`
              : "0 Results";
          });
        }
      }

      syncCoveoDistanceProductsGridVisibility(productsEl);

      const filtersModalTotal = document.getElementById(
        "coveo-filters-modal-total",
      );
      if (
        filtersModalTotal &&
        !pending &&
        typeof visible === "number" &&
        !window.__coveoDistanceFilterGracefulFallback
      ) {
        const itemsLabel = summaryEl.dataset.itemsLabel || "Boats";
        filtersModalTotal.textContent = `${Math.max(0, visible)} ${itemsLabel}`;
      }

      if (paginationEl && !pending && !usesServerSideDistanceFiltering) {
        paginationEl.innerHTML = "";
      }

      if (noResultsEl) {
        const showEmpty =
          !pending &&
          !window.__coveoDistanceFilterGracefulFallback &&
          typeof visible === "number" &&
          visible === 0;
        noResultsEl.classList.toggle("hidden", !showEmpty);
        if (showEmpty) {
          const heading = noResultsEl.querySelector(
            "#coveo-no-results-heading, .coveo-no-results__heading, h2, h3, h4",
          );
          if (heading) {
            heading.textContent = window.__coveoDistanceFilterNoIndexedGeo
              ? "No boats with location data for distance filtering. Try removing the distance filter."
              : `No boats within ${radiusMi} mi on this page. Try a larger radius or remove the distance filter.`;
          }
        }
      }
    }

    function setColumnDistanceFiltered(col, reason) {
      col.hidden = true;
      col.setAttribute("hidden", "");
      col.style.setProperty("display", "none", "important");
      col.classList.add("is-distance-filtered-out");
      col.setAttribute("data-distance-filtered", reason || "filtered");
      col.setAttribute("aria-hidden", "true");
    }

    function setColumnDistanceVisible(col, sortOrder) {
      col.hidden = false;
      col.removeAttribute("hidden");
      col.style.removeProperty("display");
      col.classList.remove("is-distance-filtered-out");
      col.removeAttribute("data-distance-filtered");
      col.removeAttribute("aria-hidden");
      if (sortOrder != null) {
        col.style.order = String(sortOrder);
      } else {
        col.style.removeProperty("order");
      }
    }

    function applyDistanceToColumn(col, card, userLat, userLng, radius, Loc) {
      const lat = parseGeoCoordinate(card.getAttribute("data-dealer-lat"));
      const lng = parseGeoCoordinate(card.getAttribute("data-dealer-lng"));
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        setColumnDistanceFiltered(col, "no-geo");
        return { withGeo: false, visible: false };
      }
      const miles = Loc.haversineDistanceMiles(userLat, userLng, lat, lng);
      if (Number.isFinite(miles) && miles <= radius) {
        setColumnDistanceVisible(col, Math.round(miles * 100));
        return { withGeo: true, visible: true };
      }
      setColumnDistanceFiltered(col, "out-of-range");
      return { withGeo: true, visible: false };
    }

    async function applyDomDistanceFilterToProductGrid(productsEl, summaryEl) {
      if (!productsEl) return { active: false };
      const currentRunId = ++domDistanceFilterRunId;
      if (isCoveoProductNavigationPendingActive()) {
        return { active: false, suspendedForNavigation: true };
      }
      const Loc = window.CoveoLocationService;
      const ctx = getActiveCoveoLocationContext();
      if (!ctx || !Loc?.haversineDistanceMiles) {
        window.__coveoDomDistanceVisibleCount = null;
        window.__coveoDomDistanceFilterPending = false;
        setCoveoDomDistanceAppliedCtxKey("");
        resetDomDistanceFilteredColumns(productsEl);
        syncCoveoDistanceProductsGridVisibility(productsEl);
        const noResultsEl = document.getElementById("coveo-no-results");
        if (noResultsEl) noResultsEl.classList.add("hidden");
        return { active: false };
      }
      const ctxKey = coveoLocationContextCacheKey(ctx);

      if (window.__coveoCollectionDistancePoolLoading) {
        resetDomDistanceFilteredColumns(productsEl);
        window.__coveoDomDistanceFilterPending = true;
        window.__coveoDomDistanceVisibleCount = null;
        window.__coveoDistanceFilterGracefulFallback = false;
        syncCoveoDistanceProductsGridVisibility(productsEl);
        refreshCoveoDistanceSummaryAndPagination();
        return { active: true, pending: true, mode: "collection-product-pool" };
      }

      if (window.__coveoClientOnlyDistanceFilter === false) {
        resetDomDistanceFilteredColumns(productsEl);
        const all = getCoveoDistanceGridItems(productsEl).length;
        window.__coveoDomDistanceFilterPending = false;
        window.__coveoDomDistanceVisibleCount = all;
        window.__coveoDistanceFilterNoIndexedGeo = false;
        window.__coveoDistanceFilterGracefulFallback = false;
        window.__coveoClientDistanceFilterActive = false;
        setCoveoDomDistanceAppliedCtxKey(ctxKey);
        syncCoveoDistanceProductsGridVisibility(productsEl);
        refreshCoveoDistanceSummaryAndPagination();
        return {
          active: true,
          visible: all,
          withGeo: all,
          total: all,
          radiusMiles: Number(ctx.location_radius_miles),
          noIndexedGeo: false,
          mode: "coveo-server-side",
        };
      }

      const userLat = Number(ctx.location_lat);
      const userLng = Number(ctx.location_lng);
      const radius = Number(ctx.location_radius_miles);
      const columns = getCoveoDistanceGridItems(productsEl);
      const storedLoc = getActiveCoveoStoredLocation() || null;
      const userZip =
        (storedLoc && (storedLoc.zip || storedLoc.approxZip)) || "";

      window.__coveoDomDistanceFilterPending = true;
      window.__coveoDomDistanceVisibleCount = null;
      window.__coveoDistanceFilterGracefulFallback = false;
      refreshCoveoDistanceSummaryAndPagination();

      columns.forEach((col) => {
        col.style.removeProperty("order");
      });

      const needsGeocode = [];
      const directRows = [];
      const zipMatchRows = [];

      columns.forEach((col) => {
        const card = getCoveoDistanceCardFromGridItem(col);
        if (!card) {
          setColumnDistanceFiltered(col, "no-card");
          return;
        }
        const lat = parseGeoCoordinate(card.getAttribute("data-dealer-lat"));
        const lng = parseGeoCoordinate(card.getAttribute("data-dealer-lng"));
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          directRows.push({ col, card });
          return;
        }
        if (userZip && cardMatchesUserZipRadius(card, userZip, radius)) {
          zipMatchRows.push({ col, card });
          return;
        }
        const placeOpts = getCardDealerPlaceOpts(card);
        if (placeOpts && Loc.buildPlaceGeocodeKey?.(placeOpts)) {
          needsGeocode.push({ col, card, placeOpts });
        } else {
          setColumnDistanceFiltered(col, "no-geo");
        }
      });

      const uniquePlaces = new Map();
      for (const row of needsGeocode) {
        if (currentRunId !== domDistanceFilterRunId) {
          return { active: true, stale: true };
        }
        const key = Loc.buildPlaceGeocodeKey(row.placeOpts);
        if (key && !uniquePlaces.has(key)) {
          uniquePlaces.set(key, row.placeOpts);
        }
      }
      const geoByKey = new Map();
      if (Loc.resolvePlaceCoordinates) {
        const placeEntries = Array.from(uniquePlaces.entries());
        const GEO_BATCH = 4;
        for (let i = 0; i < placeEntries.length; i += GEO_BATCH) {
          const batch = placeEntries.slice(i, i + GEO_BATCH);
          const resolved = await Promise.all(
            batch.map(async function (entry) {
              const key = entry[0];
              const opts = entry[1];
              try {
                const coords = await Loc.resolvePlaceCoordinates(opts);
                return { key, coords };
              } catch (_) {
                return { key, coords: null };
              }
            }),
          );
          resolved.forEach(function (row) {
            if (
              row.coords &&
              Number.isFinite(row.coords.lat) &&
              Number.isFinite(row.coords.lng)
            ) {
              geoByKey.set(row.key, row.coords);
            }
          });
        }
      }
      for (const row of needsGeocode) {
        const key = Loc.buildPlaceGeocodeKey(row.placeOpts);
        const coords = key ? geoByKey.get(key) : null;
        if (coords) {
          row.card.setAttribute("data-dealer-lat", String(coords.lat));
          row.card.setAttribute("data-dealer-lng", String(coords.lng));
          directRows.push({ col: row.col, card: row.card });
        } else {
          setColumnDistanceFiltered(row.col, "no-geo");
        }
      }

      if (currentRunId !== domDistanceFilterRunId) {
        return { active: true, stale: true };
      }

      let withGeo = 0;
      let visible = 0;
      for (const row of directRows) {
        const result = applyDistanceToColumn(
          row.col,
          row.card,
          userLat,
          userLng,
          radius,
          Loc,
        );
        if (result.withGeo) withGeo += 1;
        if (result.visible) visible += 1;
      }

      for (const row of zipMatchRows) {
        setColumnDistanceVisible(row.col, null);
        withGeo += 1;
        visible += 1;
      }

      window.__coveoDomDistanceFilterPending = false;

      if (withGeo === 0 && columns.length > 0) {
        window.__coveoDistanceFilterNoIndexedGeo = true;
        window.__coveoDistanceFilterGracefulFallback = true;
        window.__coveoClientDistanceFilterActive = false;
        window.__coveoDomDistanceVisibleCount = columns.length;
        resetDomDistanceFilteredColumns(productsEl);
      } else {
        window.__coveoDistanceFilterNoIndexedGeo = false;
        window.__coveoDistanceFilterGracefulFallback = false;
        window.__coveoClientDistanceFilterActive = withGeo > 0;
        window.__coveoDomDistanceVisibleCount = visible;
      }

      setCoveoDomDistanceAppliedCtxKey(ctxKey);
      syncCoveoDistanceProductsGridVisibility(productsEl);
      refreshCoveoDistanceSummaryAndPagination();

      return {
        active: true,
        visible,
        withGeo,
        total: columns.length,
        radiusMiles: radius,
        noIndexedGeo: window.__coveoDistanceFilterNoIndexedGeo,
      };
    }

    return {
      applyDomDistanceFilterToProductGrid,
      getCoveoDistanceGridItems,
      refreshCoveoDistanceSummaryAndPagination,
      resetDomDistanceFilteredColumns,
      setCoveoSourceIndex,
      syncCoveoDistanceProductsGridVisibility,
    };
  }

  window.CoveoDistanceModule = {
    create: createCoveoDistanceModule,
  };
})();
